import { ReactNode } from 'react';
import { GridItem, Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { Dash } from '@mews-commander/ui';

interface PaymentDetailsSidePanelRowProps {
    labelTextKey: Mews.TextKey;
    children?: ReactNode;
    hideIfNull?: boolean;
}
export const PaymentDetailsSidePanelRow = ({
    labelTextKey,
    children,
    hideIfNull = false,
}: PaymentDetailsSidePanelRowProps) => {
    if (!children && hideIfNull) {
        return null;
    }

    return (
        <>
            <GridItem>
                <Typography textStyle="bodyMedium" variant="tertiary" as="div">
                    <LocalizedText textKey={labelTextKey} />
                </Typography>
            </GridItem>
            <GridItem>{children || <Dash />}</GridItem>
        </>
    );
};
